import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';

import { SalonMonsterTapRetryComponent } from './smr-tap-retry.component';

@NgModule({
    declarations: [
        SalonMonsterTapRetryComponent
    ],
    imports: [
        IonicModule
    ],
    exports: [
        SalonMonsterTapRetryComponent
    ],
    providers: []
})
export class SalonMonsterTapRetryModule {}
